import React from "react";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import Paragraph from "../../components/common/Typography/Paragraph";

const Specialities = ({ userData, className = "" }) => {
  // Fallback data when userData is not available or specialities is empty
  const fallbackSpecialities = [
    "Air conditioning & Heating",
    "Architects & Design", 
    "Block & Awning",
    "Carpet & Flooring",
    "Bricklaying"
  ];

  // Get specialities from userData or use fallback
  const specialities = userData?.specialities && userData.specialities.length > 0 
    ? userData.specialities 
    : fallbackSpecialities;

  return (
    <div className={`mb-8 ${className}`}>
      <div>
        <SecondaryHeading variant={"MainParagraphHeading"} className={"text-offblack mb-4"}>
          Specialities
        </SecondaryHeading>
        <div className="grid grid-cols-1 gap-1">
          {specialities.slice(0, 10).map((speciality, index) => (
            <Paragraph key={index} variant={"MainParagraph"} className="text-offblack">
              {speciality}
            </Paragraph>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Specialities;
